/**
 * White-label branding configuration
 * Set VITE_BRAND_NAME environment variable to customize branding
 * Example: VITE_BRAND_NAME=Acme
 *
 * Default positioning aligns with nolij.ai:
 * "System of Action for Enterprise Operations" — resolving operational
 * exceptions across ERP, email, documents, and approvals.
 */

export const BRAND_NAME = import.meta.env.VITE_BRAND_NAME || 'Nolij';

export const BRANDING = {
  // Main brand name
  name: BRAND_NAME,

  // Application titles
  appTitle: import.meta.env.VITE_APP_TITLE || `${BRAND_NAME} — System of Action`,
  platformTitle: BRAND_NAME,

  // Positioning
  tagline: 'System of Action for Enterprise Operations',

  // Footer/powered by text
  poweredBy: `Powered by ${BRAND_NAME} Decision Loop`,

  // Login page
  loginSubtitle: 'System of Action for Enterprise Operations',
  loginHint: 'Powered by Nolij Decision Loop\nDetect · Investigate · Coordinate · Execute · Learn',
};
